<template>
  <el-card>
    <div v-if="deptData.Name" class="pad-hor mb-10" style="line-height: 40px;">
      <span class="text-dark text-xl" style="vertical-align: middle;">{{ deptData.Name }}</span>
      <el-button
        class="ml-10"
        type="primary"
        size="small"
        style="vertical-align: middle;margin-left:20px;"
        @click="editDept"
      >
        <i class="fas fa-fw fa-edit" />编辑部门
      </el-button>
      <el-button v-if="deptData.Name" class="ml-10" size="small" @click="addDeptVisible = true">
        <i class="fas fa-fw fa-plus" />添加子部门
      </el-button>
    </div>
    <div class="pl-10 mt-10" style="height: 40px; line-height: 40px;">
      <span class="text-lg">
        <i class="fa fa-users" /> 部门人员
      </span>
      <el-button class="ml-10" size="small" @click="editMembers">
        <i class="far fa-fw fa-user-circle" /> 分配成员
      </el-button>
    </div>

    <el-table :data="deptData.Members" empty-text="当前部门没有员工, 请手动分配">
      <el-table-column type="index"></el-table-column>
      <el-table-column prop="Name" label="姓名">
        <template slot-scope="scope">
          <span>{{ scope.row.Name }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Phone" label="手机"></el-table-column>
      <el-table-column width="80" label="操作">
        <template slot-scope="scope">
          <el-button type="danger" @click.stop="delItem(scope.row)" title="删除">
            <i class="fas fa-trash-alt"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      title="修改部门信息"
      :visible.sync="editDeptVisible"
      top="5vh"
      :close-on-click-modal="false"
      @close="resetDept"
    >
      <el-form ref="editDeptForm" :model="editDeptData" label-width="80px" :rules="deptRules">
        <el-form-item label="部门名称" prop="Name">
          <el-input v-model.trim="editDeptData.Name" placeholder="请输入部门名称"></el-input>
        </el-form-item>
        <el-form-item v-if="editDeptData.ParentID" label="上级部门" prop="ParentID">
          <el-cascader
            v-model="defaultCascader"
            style="width: 100%;"
            :options="cascaderOptions"
            :props="cascaderProp"
            :show-all-levels="false"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="说明" prop="remark">
          <el-input v-model.trim="editDeptData.Remark" type="textarea" placeholder="请输入部门说明"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          v-if="editDeptData.parentID"
          class="pull-left"
          type="danger"
          @click="deleteDept()">
          <i class="fas fa-trash" aria-hidden="true" /> 删 除
        </el-button>
        <el-button @click="editDeptVisible = false">
          <i class="fas fa-fw fa-times" aria-hidden="true" /> 取 消
        </el-button>
        <el-button
          type="primary"
          :disabled="deptSubmitDisable || !editDeptData.Name"
          @click="editDeptSubmit"
        >
          <i class="far fa-fw fa-save" aria-hidden="true" /> 确 定
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="新增子部门"
      :visible.sync="addDeptVisible"
      top="5vh"
      :close-on-click-modal="false"
      @close="resetAddDept"
    >
      <el-form ref="addDeptForm" :model="addDeptData" label-width="100px" :rules="addDeptRules">
        <el-form-item label="上级部门">
          <el-input v-model="deptData.Name" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="新增子部门" prop="Name">
          <el-input v-model.trim="addDeptData.Name" placeholder="请输入新增加的子部门名称"></el-input>
        </el-form-item>
        <el-form-item label="说明" prop="Remark">
          <el-input v-model.trim="addDeptData.Remark" type="textarea" placeholder="请输入部门说明"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDeptVisible = false">
          <i class="fas fa-fw fa-times" aria-hidden="true"></i> 取 消
        </el-button>
        <el-button
          type="primary"
          :disabled="addDeptSubmitDisable || !addDeptData.Name"
          @click="addDeptSubmit"
        >
          <i class="far fa-fw fa-save" aria-hidden="true"></i> 确 定
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="分配成员"
      :visible.sync="editMemberVisible"
      top="5vh"
      :close-on-click-modal="false"
      @close="resetEditMember"
      >
      <el-form ref="editMemberForm" label-width="100px">
        <el-form-item label="成员">
          <el-select
            v-model="newMemberIds"
            multiple
            clearable
            filterable
            placeholder="请选择成员"
            style="width: 100%;"
          >
            <el-option v-for="ele in userList" :key="ele.ID" :label="ele.Name" :value="ele.ID"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editMemberVisible = false">
          <i class="fas fa-fw fa-times" aria-hidden="true"></i> 取 消
        </el-button>
        <el-button type="primary" @click="editMember">
          <i class="far fa-fw fa-save" aria-hidden="true"></i> 确 定
        </el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
/* eslint-disable no-param-reassign */
// import * as _cloneDeep from 'lodash/cloneDeep';
import DeptDialogMixin from './dept-dialog-mixin';

export default {
  mixins: [
    DeptDialogMixin,
  ],
  props: {
    deptData: {
      type: Object,
      default: () => { },
    },
    deptList: {
      type: [Array, Object],
      default: () => [],
    },
  },
  data() {
    return {
      // 部门cascader默认选项
      defaultCascader: [],
      userList: [],
    };
  },
  computed: {
    // 部门cascader选项
    cascaderOptions() {
      return this.filterOption(this.deptList);
    },
  },
  watch: {
    deptData() {
      if (this.deptData) {
        if (this.cascaderOptions.length > 0 && this.deptData.ParentID) {
          this.setDefaultCascader(this.cascaderOptions);
        }
      }
    },
  },
  created() {
    this.getUserList();
  },
  methods: {
    // 只能是环保管家，subject_type='saes'
    getUserList() {
      const params = {
        return_list: 1,
      };
      this.$axios.get('user', { params }).then((response) => {
        this.userList = response.data.data;
      }, ({ response }) => {
        this.$sys.alarmResponse(response);
      });
    },
    // dept部门下的所有员工的id是数组
    getAllMemberList(dept) {
      const members = {};
      const traverse = (d) => {
        if (d.members) {
          d.members.forEach((m) => {
            members[m.ID] = m.Name;
          });
        }
        if (d.children) {
          d.children.forEach((c) => {
            traverse(c);
          });
        }
      };
      traverse(dept);
      return Object.keys(members);
    },
    // 过滤部门cascader，将部门children为空的键值删除
    filterOption(options) {
      options.forEach((opt) => {
        if (opt.children) {
          if (opt.children.length === 0) {
            delete opt.children;
          } else {
            this.filterOption(opt.children);
          }
        }
      });
      return options;
    },
    // 设置部门cascader默认选项
    setDefaultCascader(deptList, defaulId = [], defaultName = []) {
      const cacheId = [...defaulId];
      const cacheName = [...defaultName];
      deptList.forEach((dept) => {
        defaulId = [...cacheId];
        defaulId.push(dept.ID);
        defaultName = [...cacheName];
        defaultName.push(dept.name);
        if (dept.ID === this.deptData.ParentID) {
          this.defaultCascader = defaulId;
        } else if (dept.children) {
          this.setDefaultCascader(dept.children, defaulId, defaultName);
        }
      });
    },
    // 删除部门
    deleteDept() {
      this.$confirm('确定要删除这个部门吗？').then(
        () => this.$axios.delete(`department/${this.deptData.ID}`)
      ).then(() => {
        this.$message.success('成功删除部门');
        this.$emit('refresh'); // 更新用户
        this.editDeptVisible = false;
      }).catch(({ response }) => {
        this.$sys.alarmResponse(response);
      });
    },
    // 删除部门用户
    delItem(row) {
      this.$confirm('确定要从部门删除这个用户吗？').then(
        () => this.$axios.delete(`department/${this.deptData.ID}/user/${row.ID}`)
      ).then(() => {
        this.$message.success('成功删除用户');
        this.$emit('refresh'); // 更新用户
      }).catch(({ response }) => {
        this.$sys.alarmResponse(response);
      });
    },
  },
};
</script>
<style scoped>
.dept-show >>> .el-collapse-item__content {
  padding: 0;
}
.dept-show >>> .el-collapse-item__header {
  overflow: hidden;
}
.deptCheckbox {
  position: absolute;
  top: 11px;
  left: 19px;
}
.el-table >>> .bg-gray-dark {
  background-color: #e1e3e6;
}
</style>
